import { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { checkToken } from "../utils/nauth";
// import UnauthPage from "./UnauthPage";

export const PrivateRoute = ({ children }: any) => {
  const { search } = useLocation();
  // eslint-disable-next-line
  const query = new URLSearchParams(search);
  useEffect(() => {
    if (!localStorage.getItem('role')) {
      checkToken(query.get('ntoken'));
    }
    // eslint-disable-next-line
  }, [query]);
  return children;

  // if (checkAuth()) {
  //   return children;
  // } else {
  //   // console.error("유효기간 지남");
  //   /* nauth 인증을 거칠 경우 수정 필요 */
  //   return children;
  //   // eslint-disable-next-line react/react-in-jsx-scope
  //   // return <UnauthPage />;
  // }
};

export default PrivateRoute;
